const parseMesAno = (valor) => {
  if (valor === null || valor === undefined || valor === "") {
    return null;
  }

  if (Array.isArray(valor) && valor.length >= 2) {
    const ano = Number(valor[0]);
    const mes = Number(valor[1]);

    if (Number.isInteger(ano) && Number.isInteger(mes) && mes >= 1 && mes <= 12) {
      return { ano, mes };
    }

    return null;
  }

  const texto = String(valor).trim();

  if (/^\d{4}-\d{2}$/.test(texto)) {
    const [ano, mes] = texto.split("-").map(Number);
    return { ano, mes };
  }

  if (/^\d{2}\/\d{4}$/.test(texto)) {
    const [mes, ano] = texto.split("/").map(Number);
    return { ano, mes };
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) {
    const [ano, mes] = texto.split("-").map(Number);
    return { ano, mes };
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
    const partes = texto.split("/").map(Number);
    return { ano: partes[2], mes: partes[1] };
  }

  return null;
};

export const getMesAtualInput = () => {
  const now = new Date();
  const ano = now.getFullYear();
  const mes = String(now.getMonth() + 1).padStart(2, "0");
  return `${ano}-${mes}`;
};

export const getCompetenciaAtual = () => {
  return inputMesParaCompetencia(getMesAtualInput());
};

export const getCompetenciaComOffset = (offsetMeses = 0) => {
  const now = new Date();
  const data = new Date(now.getFullYear(), now.getMonth() + Number(offsetMeses || 0), 1);
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();
  return `${mes}/${ano}`;
};

export const inputMesParaCompetencia = (valor) => {
  const parsed = parseMesAno(valor);

  if (!parsed) {
    return "";
  }

  return `${String(parsed.mes).padStart(2, "0")}/${parsed.ano}`;
};

export const competenciaParaInputMes = (valor) => {
  const parsed = parseMesAno(valor);

  if (!parsed) {
    return "";
  }

  return `${parsed.ano}-${String(parsed.mes).padStart(2, "0")}`;
};

export const normalizarCompetencia = (valor) => {
  return inputMesParaCompetencia(valor);
};

export const formatarCompetenciaMesAno = (valor) => {
  const formatted = inputMesParaCompetencia(valor);
  return formatted || "-";
};

export const competenciaParaTimestamp = (valor) => {
  const inputMes = competenciaParaInputMes(valor);

  if (!inputMes) {
    return 0;
  }

  return new Date(`${inputMes}-01`).getTime();
};
